import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initAwards = () => {
	const sections = document.querySelectorAll('[data-awards]')

	sections.forEach(section => {
		const items = section.querySelectorAll('[data-awards-item]')
		const logos = section.querySelectorAll('[data-awards-logo]')

		items.forEach((item, i) => {
			const isLast = i === items.length - 1

			if (isLast) {
				ScrollTrigger.create({
					trigger: item,
					start: 'top 50%-=32px',
					onEnter: () => {
						item.classList.add('js-active')
						logos[i]?.classList.add('js-active')
					},
					onLeaveBack: () => {
						item.classList.remove('js-active')
						logos[i]?.classList.remove('js-active')
					}
				})
			} else {
				ScrollTrigger.create({
					trigger: item,
					start: 'top 50%-=32px',
					end: 'bottom 50%-=32px',
					toggleClass: {
						targets: [item, logos[i]],
						className: 'js-active',
						toggleClass: 'js-active'
					}
				})
			}
		})
	})
}